import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
  providedIn: 'root',
})
export class ProfileImageService {
  private profileImage = new BehaviorSubject<any>(null); // Initialize BehaviorSubject with null or default value
  profileImg$ = this.profileImage.asObservable(); // Expose tasks as observable

  constructor(
    private localStorage: LocalStorageService
  ) {}

  setImage(newTasks: any) {
    this.profileImage.next(newTasks);
  }

}
